import React from 'react'

export default function NotFound() {
  return (
    <div>
    <h1>404 Error</h1>
      <h3>Page Not Found</h3>
      <h6>Requested page is not found</h6>
    </div>
  )
}
